export const createEmptyField = () => ({
  members: [],
});

export const createEmptyMember = () => ({
  source: 'Unmapped',
  value: 'Unmapped',
  precedingDelimiter: 'Empty',
});

export const createCustomFieldChangeObject = (
  rule,
  fieldName,
  memberIndex,
  newValue
) => ({
  eventType: rule.eventType,
  ruleIndex: rule.index,
  fieldName,
  memberIndex,
  newValue,
});

export const createAccountObjectChangeObject = (
  rule,
  transactionType,
  objectIndex,
  memberIndex,
  newValue
) => ({
  eventType: rule.eventType,
  ruleIndex: rule.index,
  transactionType,
  objectIndex,
  memberIndex,
  newValue,
});

const createAccount = accountingObjects => ({
  accountNumber: null,
  objectMappings: accountingObjects.map(object => ({
    index: object.index,
    field: createEmptyField(),
    object,
  })),
});

export const createEmptyRule = (eventType, accountingObjects) => ({
  eventType,
  credit: createAccount(accountingObjects),
  debit: createAccount(accountingObjects),
  series: createEmptyField(),
  company: createEmptyField(),
  voucherText: createEmptyField(),
  transactionText: createEmptyField(),
});
